import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useOrganizations } from '@/hooks/useOrganizations';
import { useProductCategories } from '@/hooks/warehouse';

interface WarehouseFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  organizationId: string;
  onOrganizationChange: (value: string) => void;
  category: string;
  onCategoryChange: (value: string) => void;
  onClear: () => void;
}

const WarehouseFilters = ({
  searchTerm,
  onSearchChange,
  organizationId,
  onOrganizationChange,
  category,
  onCategoryChange,
  onClear,
}: WarehouseFiltersProps) => {
  const { data: organizations = [] } = useOrganizations();
  const { categories } = useProductCategories();

  const hasActiveFilters = searchTerm || organizationId || category;

  return (
    <div className="flex items-center gap-2">
      {/* Search Input */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Buscar por nombre o descripción..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9 w-[200px] rounded-full bg-gray-100 hover:bg-gray-200 transition-colors border-0 h-10"
        />
      </div>

      {/* Organization Filter */}
      <Select value={organizationId} onValueChange={onOrganizationChange}>
        <SelectTrigger className="w-[180px] rounded-full bg-gray-100 hover:bg-gray-200 transition-colors border-0">
          <SelectValue placeholder="Organización" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todas las organizaciones</SelectItem>
          {organizations.map((org) => (
            <SelectItem key={org.id} value={org.id}>
              {org.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Category Filter */}
      <Select value={category} onValueChange={onCategoryChange}>
        <SelectTrigger className="w-[180px] rounded-full bg-gray-100 hover:bg-gray-200 transition-colors border-0">
          <SelectValue placeholder="Categoría" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todas las categorías</SelectItem>
          {categories.map((cat) => (
            <SelectItem key={cat.id} value={cat.id}>
              {cat.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Clear Filters Button */}
      {hasActiveFilters && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onClear}
          className="h-10 w-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};

export default WarehouseFilters;
